import React from 'react';

export function RulesIcon() {
  return (
    <svg stroke="currentColor" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="1.25" y="1.625" width="5.25" height="5.25" rx="1" strokeWidth="1.5" />
      <circle cx="12.25" cy="4.25" r="2.75" strokeWidth="1.5" />
      <circle cx="3.75" cy="11.75" r="2.75" strokeWidth="1.5" />
      <rect x="9.5" y="9.125" width="5.25" height="5.25" rx="1" strokeWidth="1.5" />
    </svg>
  );
}
